module.exports = __webpack_public_path__ + "static/media/phone-green.054db87f.svg";